export default __webpack_public_path__ + "static/media/gallery - intro_02.2e8b8b52.jpg";